<template>
  <div>
    <el-row>
      <el-col :span="8">
        <div class="block">
          <span class="demonstration">加盟商选择：</span>
          <el-select
            v-model="selectedVendor"
            multiple
            filterable
            value-key="vendorid"
            :multiple-limit="3"
            placeholder="请选择且最多选择三个加盟商"
            style="width:66.6666666666%;"
          >
            <el-option
              v-for="item in vendorsList"
              :key="item.vendorid"
              :label="item.vendorName"
              :value="item.vendorid"
            ></el-option>
          </el-select>
        </div>
      </el-col>
    </el-row>
    <el-row class="m-mt20">
      <el-col :span="18">
        <div class="block">
          <span class="demonstration">时间范围：</span>
          <!-- <el-time-picker
            is-range
            v-model="hourRange"
            range-separator="~"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            placeholder="选择时间范围"
          >
          </el-time-picker> -->
          <el-date-picker
            v-model="hourRange"
            type="daterange"
            range-separator="~"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
          <el-button
            type="primary"
            icon="el-icon-search"
            class="m-ml10"
            @click="handleClickHour"
            >订单时间段分布查询</el-button
          >
        </div>
      </el-col>
    </el-row>
    <el-row class="m-mt20">
      <el-col :span="12">
        <ve-histogram
          :data="amountByVendorHour"
          :title="{ text: '订单金额时间段分布统计', left: 'center' }"
          :legend="{ top: 36 }"
          :grid="{ top: 80 }"
          :dataZoom="dataZoomOptions"
        >
          <div
            class="data-empty"
            v-if="!amountByVendorHour.rows || !amountByVendorHour.rows.length"
          >
            没有数据😂
          </div>
        </ve-histogram>
      </el-col>
      <el-col :span="12">
        <ve-histogram
          :data="countByVendorHour"
          :title="{ text: '订单数量时间段分布统计', left: 'center' }"
          :legend="{ top: 36 }"
          :grid="{ top: 80 }"
          :dataZoom="dataZoomOptions"
        >
          <div
            class="data-empty"
            v-if="!countByVendorHour.rows || !countByVendorHour.rows.length"
          >
            没有数据😂
          </div>
        </ve-histogram>
      </el-col>
    </el-row>
    <el-row class="m-mt20">
      <el-col :span="12">
        <ve-pie
          :data="fromHistogramToPieForHours(amountByVendorHour)"
          :settings="orderRatechartSettingsHour"
          :title="{ text: '订单金额时间段占有率', left: 'center' }"
          :legend="{ top: 50 }"
          height="500px"
        >
          <div
            class="data-empty"
            v-if="!amountByVendorHour.rows || !amountByVendorHour.rows.length"
          >
            没有数据😂
          </div>
        </ve-pie>
      </el-col>
      <el-col :span="12">
        <ve-pie
          :data="fromHistogramToPieForHours(countByVendorHour)"
          :settings="orderRatechartSettingsHour"
          :title="{ text: '订单数量时间段占有率', left: 'center' }"
          :legend="{ top: 50 }"
          height="500px"
        >
          <div
            class="data-empty"
            v-if="!countByVendorHour.rows || !countByVendorHour.rows.length"
          >
            没有数据😂
          </div>
        </ve-pie>
      </el-col>
    </el-row>
    <hr />
    <el-row class="m-mt20">
      <el-col :span="18">
        <div class="block">
          <span class="demonstration">日期范围：</span>
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            range-separator="~"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
          <el-button
            type="primary"
            icon="el-icon-search"
            class="m-ml10"
            @click="handleClickDaily"
            >每日订单查询</el-button
          >
        </div>
      </el-col>
    </el-row>
    <el-row class="m-mt20">
      <el-col :span="12">
        <ve-histogram
          :data="amountByVendorDaily"
          :title="{ text: '每日订单金额', left: 'center' }"
          :legend="{ top: 36 }"
          :grid="{ top: 80 }"
          :dataZoom="dataZoomOptions"
        >
          <div
            class="data-empty"
            v-if="!amountByVendorDaily.rows || !amountByVendorDaily.rows.length"
          >
            没有数据😂
          </div>
        </ve-histogram>
      </el-col>
      <el-col :span="12">
        <ve-histogram
          :data="countByVendorDaily"
          :title="{ text: '每日订单数量', left: 'center' }"
          :legend="{ top: 36 }"
          :grid="{ top: 80 }"
          :dataZoom="dataZoomOptions"
        >
          <div
            class="data-empty"
            v-if="!countByVendorDaily.rows || !countByVendorDaily.rows.length"
          >
            没有数据😂
          </div>
        </ve-histogram>
      </el-col>
    </el-row>
    <el-row class="m-mt20">
      <el-col :span="12">
        <ve-pie
          :data="fromHistogramToPie('加盟商', '订单金额', amountByVendorDaily)"
          :settings="orderRatechartSettings"
          :title="{ text: '订单金额每日占有率', left: 'center' }"
          :legend="{ top: 50 }"
        >
          <div
            class="data-empty"
            v-if="!amountByVendorDaily.rows || !amountByVendorDaily.rows.length"
          >
            没有数据😂
          </div>
        </ve-pie>
      </el-col>
      <el-col :span="12">
        <ve-pie
          :data="fromHistogramToPie('加盟商', '订单数量', countByVendorDaily)"
          :settings="orderRatechartSettings"
          :title="{ text: '订单数量每日占有率', left: 'center' }"
          :legend="{ top: 50 }"
        >
          <div
            class="data-empty"
            v-if="!countByVendorDaily.rows || !countByVendorDaily.rows.length"
          >
            没有数据😂
          </div>
        </ve-pie>
      </el-col>
    </el-row>
    <hr />
    <el-row class="m-mt20">
      <el-col :span="18">
        <div class="block">
          <span class="demonstration">月份范围：</span>
          <el-date-picker
            v-model="monthRange"
            type="monthrange"
            range-separator="~"
            start-placeholder="开始月份"
            end-placeholder="结束月份"
          >
          </el-date-picker>
          <el-button
            type="primary"
            icon="el-icon-search"
            class="m-ml10"
            @click="handleClickMonth"
            >月度订单查询</el-button
          >
        </div>
      </el-col>
    </el-row>
    <el-row class="m-mt20">
      <el-col :span="12">
        <ve-histogram
          :data="amountByVendorMonth"
          :title="{ text: '每月订单金额', left: 'center' }"
          :legend="{ top: 36 }"
          :grid="{ top: 80 }"
          :dataZoom="dataZoomOptions"
        >
          <div
            class="data-empty"
            v-if="!amountByVendorMonth.rows || !amountByVendorMonth.rows.length"
          >
            没有数据😂
          </div>
        </ve-histogram>
      </el-col>
      <el-col :span="12">
        <ve-histogram
          :data="countByVendorMonth"
          :title="{ text: '每月订单数量', left: 'center' }"
          :legend="{ top: 36 }"
          :grid="{ top: 80 }"
          :dataZoom="dataZoomOptions"
        >
          <div
            class="data-empty"
            v-if="!countByVendorMonth.rows || !countByVendorMonth.rows.length"
          >
            没有数据😂
          </div>
        </ve-histogram>
      </el-col>
    </el-row>
    <el-row class="m-mt20">
      <el-col :span="12">
        <ve-pie
          :data="fromHistogramToPie('加盟商', '订单金额', amountByVendorMonth)"
          :settings="orderRatechartSettings"
          :title="{ text: '订单金额每月占有率', left: 'center' }"
          :legend="{ top: 50 }"
        >
          <div
            class="data-empty"
            v-if="!amountByVendorMonth.rows || !amountByVendorMonth.rows.length"
          >
            没有数据😂
          </div>
        </ve-pie>
      </el-col>
      <el-col :span="12">
        <ve-pie
          :data="fromHistogramToPie('加盟商', '订单数量', countByVendorMonth)"
          :settings="orderRatechartSettings"
          :title="{ text: '订单数量每月占有率', left: 'center' }"
          :legend="{ top: 50 }"
        >
          <div
            class="data-empty"
            v-if="!countByVendorMonth.rows || !countByVendorMonth.rows.length"
          >
            没有数据😂
          </div>
        </ve-pie>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import moment from "moment";
export default {
  data() {
    return {
      vendorsList: [],
      dataZoomOptions: {
        type: "slider"
      },
      selectedVendor: [],
      hourRange: [],
      dateRange: [],
      monthRange: [],
      amountByVendorDaily: {},
      countByVendorDaily: {},
      amountByVendorMonth: {},
      countByVendorMonth: {},
      amountByVendorHour: {},
      countByVendorHour: {},
      orderRatechartSettings: {
        radius: 120,
        offsetY: 250
      },
      orderRatechartSettingsHour: {
        radius: 120,
        offsetY: 320
      }
    };
  },
  methods: {
    getOrderReportAmountByVendorDaily(selectedVendor, dateRange) {
      return new Promise(resolve => {
        this.$axios(this.$urlMapping["查询加盟商每日订单金额"], {
          data: {
            vendorids: selectedVendor,
            from: this.$ToDateTimeString(dateRange[0]),
            to: this.$ToDateTimeString(dateRange[1])
          }
        }).then(result => {
          resolve(result);
        });
      });
    },
    getOrderReportCountByVendorDaily(selectedVendor, dateRange) {
      return new Promise(resolve => {
        this.$axios(this.$urlMapping["查询加盟商每日订单总量"], {
          data: {
            vendorids: selectedVendor,
            from: this.$ToDateTimeString(dateRange[0]),
            to: this.$ToDateTimeString(dateRange[1])
          }
        }).then(result => {
          resolve(result);
        });
      });
    },
    getOrderReportAmountByVendorHourly(selectedVendor, hourRange) {
      return new Promise(resolve => {
        this.$axios(this.$urlMapping["查询加盟商每小时订单金额"], {
          data: {
            vendorids: selectedVendor,
            from: this.$ToDateTimeString(hourRange[0]),
            to: this.$ToDateTimeString(hourRange[1])
          }
        }).then(result => {
          resolve(result);
        });
      });
    },
    getOrderReportCountByVendorHourly(selectedVendor, hourRange) {
      return new Promise(resolve => {
        this.$axios(this.$urlMapping["查询加盟商每小时订单总量"], {
          data: {
            vendorids: selectedVendor,
            from: this.$ToDateTimeString(hourRange[0]),
            to: this.$ToDateTimeString(hourRange[1])
          }
        }).then(result => {
          resolve(result);
        });
      });
    },
    getOrderReportAmountByVendorMonthly(selectedVendor, monthRange) {
      return new Promise(resolve => {
        this.$axios(this.$urlMapping["查询加盟商每月订单金额"], {
          data: {
            vendorids: selectedVendor,
            from: this.$ToDateTimeString(monthRange[0]),
            to: this.$ToDateTimeString(monthRange[1])
          }
        }).then(result => {
          resolve(result);
        });
      });
    },
    getOrderReportCountByVendorMonthly(selectedVendor, monthRange) {
      return new Promise(resolve => {
        this.$axios(this.$urlMapping["查询加盟商每月订单总量"], {
          data: {
            vendorids: selectedVendor,
            from: this.$ToDateTimeString(monthRange[0]),
            to: this.$ToDateTimeString(monthRange[1])
          }
        }).then(result => {
          resolve(result);
        });
      });
    },
    handleClickDaily() {
      if (
        Array.isArray(this.dateRange) &&
        this.dateRange.length > 0 &&
        this.selectedVendor.length > 0
      ) {
        Promise.all([
          this.getOrderReportAmountByVendorDaily(
            this.selectedVendor,
            this.dateRange
          ),
          this.getOrderReportCountByVendorDaily(
            this.selectedVendor,
            this.dateRange
          )
        ])
          .then(values => {
            this.amountByVendorDaily = values[0];
            this.countByVendorDaily = values[1];
          })
          .catch(reason => {
            console.log(reason);
          });
      } else {
        this.$notify.error({
          title: "消息",
          message: "请选择加盟商和时间范围后再查询"
        });
      }
    },
    handleClickMonth() {
      if (
        Array.isArray(this.monthRange) &&
        this.monthRange.length > 0 &&
        this.selectedVendor.length > 0
      ) {
        Promise.all([
          this.getOrderReportAmountByVendorMonthly(
            this.selectedVendor,
            this.monthRange
          ),
          this.getOrderReportCountByVendorMonthly(
            this.selectedVendor,
            this.monthRange
          )
        ])
          .then(values => {
            this.amountByVendorMonth = values[0];
            this.countByVendorMonth = values[1];
          })
          .catch(reason => {
            console.log(reason);
          });
      } else {
        this.$notify.error({
          title: "消息",
          message: "请选择加盟商和月份范围后再查询"
        });
      }
    },
    handleClickHour() {
      if (
        Array.isArray(this.hourRange) &&
        this.hourRange.length > 0 &&
        this.selectedVendor.length > 0
      ) {
        Promise.all([
          this.getOrderReportAmountByVendorHourly(
            this.selectedVendor,
            this.hourRange
          ),
          this.getOrderReportCountByVendorHourly(
            this.selectedVendor,
            this.hourRange
          )
        ])
          .then(values => {
            this.amountByVendorHour = values[0];
            this.countByVendorHour = values[1];
          })
          .catch(reason => {
            console.log(reason);
          });
      } else {
        this.$notify.error({
          title: "消息",
          message: "请选择加盟商和时间范围后再查询"
        });
      }
    }
  },
  mounted() {
    this.$axios(this.$urlMapping["查询加盟商"], {
      data: {}
    }).then(result => {
      this.vendorsList = result.data;
      let count = this.vendorsList.length > 3 ? 3 : this.vendorsList.length;
      for (let index = 0; index < count; index++) {
        this.selectedVendor.push(this.vendorsList[index].vendorid);
      }
      if (this.$route.query.vendorid) {
        this.selectedVendor = [this.$route.query.vendorid];
        // this.selectedVendor = this.selectedVendor.filter(
        //   ele => ele === this.$route.query.vendorid
        // );
      }
      this.hourRange = this.dateRange = this.monthRange = [
        moment().subtract(1, "days"),
        moment()
      ];
      this.$nextTick(() => this.handleClickHour());
      this.$nextTick(() => this.handleClickDaily());
      this.$nextTick(() => this.handleClickMonth());
    });
  }
};
</script>

<style lang="less" scoped></style>
